<template>
    <div>
        <template v-if="crud_expense_category == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Add Expense Category</h1>
            </div>
            <div class="company-main">
                <form id="roleForm" @submit.prevent="addExpenseCategory">
                    <div class="tab-content-inner">
                        <template>
                            <div class="people-management-inner-content p-5">
                                <div class="user-permissions">
                                    <div class="form-group">
                                        <label> Name </label>
                                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" autocomplete="off">
                                        <has-error :form="form" field="name"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                        <router-link to="/expenseCategories" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </form>
            </div>
        </template>
        <template v-if="crud_expense_category == null">
            <preLoader></preLoader>
        </template>
        <template v-if="crud_expense_category == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
                crud_expense_category : null,
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('expense_categories_crud').then(result => {
                this.crud_expense_category = result.expense_categories_crud;
                this.$Progress.finish();
            });
        },
        methods: {
            addExpenseCategory() {
                this.$Progress.start();
                this.form.post('api/eMoney/addExpenseCategory')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        if(res.data.data == "Duplicate"){
                            this.showToastBox('error', 'Category already added please use different category name!');
                        }else{
                            this.showToastBox('success', 'Category added successfully');
                            this.$router.push('/expenseCategories');
                        }
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            }
        }
    }
</script>
